// src/App.tsx
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { SettingsProvider } from './contexts/SettingsContext';
import { ToastProvider } from './contexts/ToastContext';
import { AppLayout } from './layouts/AppLayout';
import { Login } from './pages/Login';
import { ForcePasswordChange } from './pages/ForcePasswordChange';
import { Dashboard } from './pages/Dashboard';
import { Departments } from './pages/Departments';
import { Users } from './pages/Users';
import { RolesPermissions } from './pages/RolesPermissions';
import { Products } from './pages/Products';
import { ProductionBatches } from './pages/ProductionBatches';
import { StockInventory } from './pages/StockInventory';
import { SalesProfitability } from './pages/SalesProfitability';
import { InvoicesLedger } from './pages/InvoicesLedger';
import { AuditLogs } from './pages/AuditLogs';
import { MyProfile } from './pages/MyProfile';
import { Settings } from './pages/Settings';
import { CreditApplications } from './pages/CreditApplications';
import { CreditApplicationDetails } from './pages/CreditApplicationDetails';
import { CreditApplicationForm } from './pages/public/CreditApplicationForm';
import { CreditApplicationConfirmation } from './pages/public/CreditApplicationConfirmation';

export const App: React.FC = () => {
  return (
    <BrowserRouter>
      <ToastProvider>
        <SettingsProvider>
          <AuthProvider>
            <Routes>
              {/* Public & Mandatory Transition Routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/change-password" element={<ForcePasswordChange />} />

              {/* Public Customer Credit Application Routes (Independent Lightweight Layout) */}
              <Route path="/credit-application/:token" element={<CreditApplicationForm />} />
              <Route path="/credit-application/:token/confirmation" element={<CreditApplicationConfirmation />} />

              {/* Protected App Routes */}
              <Route element={<AppLayout />}>
                <Route path="/" element={<Navigate to="/dashboard" replace />} />
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/products" element={<Products />} />
                <Route path="/stock-inventory" element={<StockInventory />} />
                <Route path="/production-batches" element={<ProductionBatches />} />
                <Route path="/sales-profitability" element={<SalesProfitability />} />
                <Route path="/invoices" element={<InvoicesLedger />} />
                <Route path="/credit-applications" element={<CreditApplications />} />
                <Route path="/credit-applications/:id" element={<CreditApplicationDetails />} />
                <Route path="/departments" element={<Departments />} />
                <Route path="/users" element={<Users />} />
                <Route path="/roles" element={<RolesPermissions />} />
                <Route path="/audit-logs" element={<AuditLogs />} />
                <Route path="/profile" element={<MyProfile />} />
                <Route path="/settings" element={<Settings />} />
              </Route>

              {/* Fallback */}
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
          </AuthProvider>
        </SettingsProvider>
      </ToastProvider>
    </BrowserRouter>
  );
};

export default App;
